module.exports = __webpack_public_path__ + "img/Tier_Dekon_und_Transportgruppe.c7d57769.svg";